import type { Answer } from 'types/answers'

export type AnswerTranslationResponse = {
    success: boolean
    translated_content?: Record<string, string>
    detected_lang?: Answer['detected_lang']
    updated_at?: Answer['updated_at'] | string
    error?: string
}

export function translatedAnswerFromResponse(
    cachedAnswer: Answer | null | undefined,
    response: AnswerTranslationResponse,
): Answer | null {
    if (!cachedAnswer || !response.success || !response.translated_content) return null

    return {
        ...cachedAnswer,
        content_translated: {
            ...(cachedAnswer.content_translated || {}),
            ...response.translated_content,
        },
        ...(response.detected_lang !== undefined ? { detected_lang: response.detected_lang } : {}),
        ...(response.updated_at ? { updated_at: response.updated_at } : {}),
    } as Answer
}
